import React from 'react';
import { Link } from 'react-router-dom';
import Card from './Card';
import { motion } from 'framer-motion';

const Section = ({ title, data, link, allowAddToCart = false }) => {
  const actionLabel = `Knowledge Library`;

  return (
    <section className="pp-section">
      <div className="pp-section-header">
        {/* NEW: Flex container to keep title and link together */}
        <div className="left-aligned-header">
          <div className="header-title-group">
            <h2>{title}</h2>
            <div className="title-underline"></div>
          </div>
          
          <Link to={link} className="modern-action-link">
            <span>{actionLabel}</span>
            <svg 
              width="18" height="18" viewBox="0 0 24 24" fill="none" 
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </Link>
        </div>
      </div>

      <motion.div 
        className="pp-grid"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
          hidden: { opacity: 0 },
          show: {
            opacity: 1,
            transition: { staggerChildren: 0.1 }
          }
        }}
      >
        {data.slice(0, 4).map(item => (
          <Card key={item.id} item={item} showAddToCart={allowAddToCart} />
        ))}
      </motion.div>
    </section>
  );
};

export default Section;